import { createApiV2 } from "./common";

export const getInvoiceDisplayMode =
  ({ orderUid, invoiceType }) =>
  (token) =>
    createApiV2("GET", "pdf/invoice_display_mode/")(token, {
      invoice_type: invoiceType,
      order_id: orderUid,
    });
